import { joinNameParts } from 'Components/Core/InjectedPropsContext/NamePrefixModifier/helpers';
import { RecordGridFieldSet, RecordProps, RecordGridField } from '.';
/**
 * Returns whether removing record at index is prevented for the given record management properties
 */
export const isRemovePrevented = (index: number, recordCount: number, recordProps: RecordProps) => {
  const recordGroupingSize = recordProps.recordGroupingSize ?? 1;
  if (recordProps?.enforceAtLeastOneRecord && recordCount <= 1) return true;

  // Where records are grouped, we always prevent removal of records other than the last in the group
  if ((index + 1) % recordGroupingSize !== 0 && index !== recordCount - 1) return true;

  // Special options
  if (recordProps?.preventRemove === 'all-but-last') return index < recordCount - recordGroupingSize;

  // Index variable
  if (typeof recordProps?.preventRemove === 'function') return recordProps?.preventRemove(index);

  // Off/on
  if (typeof recordProps?.preventRemove === 'boolean') return recordProps?.preventRemove;
};

/**
 * Returns whether creating record at index is prevented for the given record management properties
 */
export const isCreatePrevented = (recordCount: number, recordProps: RecordProps) => {
  // Index variable
  if (typeof recordProps?.preventCreate === 'function') return recordProps?.preventCreate(recordCount);

  // Off/on
  if (typeof recordProps?.preventCreate === 'boolean') return recordProps?.preventCreate;
};

/**
 * Prefixes all of the names of fields/sub-record sets in a given field set
 *
 * Useful when including a field set for an embedded test
 */
export const prefixRecordFieldSetNames = (prefix: string, fieldSet: RecordGridFieldSet) =>
  fieldSet.map((f) => ({
    ...f,
    name: joinNameParts(prefix, f.name),
    additionalMessagePaths: (f as RecordGridField)?.additionalMessagePaths?.map((p) => joinNameParts(prefix, p)),
  }));

/**
 * Returns the header for a record based on the "heading" property
 */
export const getRecordHeader = (heading: RecordProps['heading'], index: number) =>
  heading === 'number' ? `${index + 1}` : heading?.(index);
